import axios from "axios"
import { serverUrl } from "../../ApiRoute"
import store from "../redux"
import { messages } from "../common/notification"

export const controlMegaController = async(details) => {
    let login = store.getState().login
    let currentState = details.stateAppliance
    currentState = currentState === 1 ? 0 : 1
    let applianceState = details.stateBinary.split("")
    applianceState[details.index] = currentState
    applianceState = applianceState.join("")
    const decimal = parseInt(applianceState, 2);
   return await axios.post(`${serverUrl.megaController}/device/control`,{
        "deviceId": details.deviceId,
        "command": decimal,
        "controllerType": "user", 
        "controllerId": `${login?.profile?.first_name} (${login?.profile?.email})` ,
        "controllerDetails": {
            "userId": login?.profile?._id
        },
        "id": new Date().getTime().toString(32),
        "control": true
     }).then(res=>{
        if(res.data.success){
            messages.success("Controller updated successfully")
            return {success:true,currentState,applianceState}
        }else{
            messages.error(res?.data?.message || "Controller update failed")
            return {success:false}
        }

     }).catch(err=>{
        let msg = err?.response?.data?.message || err?.message || "Controller update failed"
        messages.error(msg)
        return {success:false}
     })
} 

export const getMegaController = async(deviceId) => {
    return await axios.post(`${serverUrl.megaController}/devices/details`,{
        "deviceIds": deviceId
     }).then(res=>{
        if(res.data.success){
            return res.data
        }else{     
            return {success:false}
        }
     }).catch(err=>{
        let msg = err?.response?.data?.message || err?.message
        // messages.error(msg)
        return {success:false}
     })
}